import React from "react";
const TextBox = (props) => {
  let maxLength = props.maxLength ? props.maxLength : 200;
  return (
    <React.Fragment>
      <div className={"form-group"}>
        <label>
          {props.label}
          {props.required ? (
            <span className="mandatory">
              * &nbsp; <span className="error-msg">{props.error}</span>
            </span>
          ) : null}
        </label>
        <input
          type={props.type}
          maxLength={maxLength}
          value={props.value}
          name={props.name}
          className={props.error ? "is-invalid form-control" : "form-control"}
          onChange={props.onChange}
          disabled={props.disabled || false}
          readOnly={props.disabled || false}
          autoComplete={props.autoComplete || "nofill"}
        />
      </div>
    </React.Fragment>
  );
};
export default TextBox;
